import { apiSlice } from "../../app/api/apiSlice";

export const updatePendingApplicationDirectPathApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		updatePendingApplicationDirectPath: builder.mutation({
			query: (payload) => ({
				url: "/api/v1/loan/update_pending_application_direct_path/",
				method: "POST",
				body: {
					loan_history_id: payload?.loanHistoryId,
					direct_path: payload?.directPath,
				},
			}),
		}),
	}),
});

export const { useUpdatePendingApplicationDirectPathMutation } =
	updatePendingApplicationDirectPathApiSlice;
